import { mapMutations } from 'vuex';

import { ProgressLayout } from 'ipro-ui-kit-vuejs/src/layouts';

import { ContainerMixin, ActionOnPageFocusMixin } from '@/core/mixins';
import { WorkerInductionService, WorkerInductionConstants } from '@/core/worker-induction';

// @vue/component
export default {
  components: {
    ProgressLayout,
  },
  mixins: [
    ContainerMixin,
    ActionOnPageFocusMixin,
  ],
  data() {
    return {
      requestInProgress: false,
      workerInduction: {},
      showNotFoundMessage: false,
    };
  },
  computed: {
    inductionName() {
      return this.showNotFoundMessage ? 'Induction not found' : _.get(this.workerInduction, 'induction_name', 'Induction');
    },
    inductionUrl() {
      const inductionUrl = _.get(this.$route, 'query.induction_url', '');
      return decodeURIComponent(inductionUrl);
    },
    inductionToken() {
      const url = new URL(this.inductionUrl);
      return url.searchParams.get('token');
    },
    isCompleted() {
      return _.get(this.workerInduction, 'current_status') === _.get(WorkerInductionConstants, 'current_status.completed.key');
    },
    resolvedInductionUrl() {
      if (!this.inductionUrl) {
        return '';
      }

      const redirectUrl = encodeURIComponent(window.location.href);
      const urlHasQueryParams = this.inductionUrl.includes('?');
      return `${this.inductionUrl}${urlHasQueryParams ? '&' : '?'}redirect_to=${redirectUrl}`;
    },
  },
  watch: {
    inductionName(inductionName) {
      this.setPageTitle(inductionName);
    },
  },
  created() {
    if (!this.inductionUrl || !this.inductionToken) {
      this.showNotFoundMessage = true;
    } else {
      this.fetchWorkerInduction();
    }
  },
  methods: {
    ...mapMutations(['setPageTitle']),
    async fetchWorkerInduction() {
      this.requestInProgress = true;

      try {
        this.workerInduction = await WorkerInductionService.getByToken(this.inductionToken);
      } catch (error) {
        this.showNotFoundMessage = true;
      }

      this.requestInProgress = false;
    },
    performActionIfFocused() {
      if (!this.isCompleted && !_.isEmpty(this.workerInduction)) {
        this.fetchWorkerInduction();
      }
    },
  },
};
